export interface PersonalRouter {
  goToList(userId: string, query?: string): void;
  goToListWithState(userId: string, state: unknown): void;
  redirectToHome(): void;
  goToWorkBook(userId: string, employeeId: string): void;
  goToEducation(userId: string, employeeId: string): void;
  goToAdditionalEducation(userId: string, employeeId: string): void;
  goToEmploymentContract(userId: string, employeeId: string): void;
  goToWorkHistory(userId: string, employeeId: string): void;
  goToAwardsPage(userId: string, employeeId: string): void;
  goToRelativesPage(userId: string, employeeId: string): void;
  goBack(): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonalRouter = Symbol('PersonalRouter');
